import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Typography,
  Box,
} from "@mui/material";
import CallSplitIcon from "@mui/icons-material/CallSplit";
import { axiosConfig } from "../../axios/axiosConfig";

const StockSplit = () => {
  const [splits, setSplits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSplits = async () => {
      try {
        setLoading(true);

        const response = await axiosConfig({
          method: "get",
          url: "/stock-splits/",
        });
        setSplits(response.data);
      } catch (err) {
        setError("Failed to fetch stock splits.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchSplits();
  }, []);

  if (loading)
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress sx={{ color: "#016551" }} />
      </Box>
    );

  if (error)
    return (
      <Typography color="error" align="center" mt={5}>
        {error}
      </Typography>
    );

  return (
    <Box sx={{ p: 3, background: "#eef2f7", minHeight: "100vh" }}>
      {/* Page Header */}
      <Box
        sx={{
          background: "#04343a",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(4,52,58,0.3)",
          p: "20px 28px",
          mb: 3,
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        <CallSplitIcon sx={{ color: "#fff", fontSize: 32 }} />
        <Box>
          <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "20px" }}>
            Stock Splits
          </Typography>
          <Typography sx={{ color: "rgba(255,255,255,0.65)", fontSize: "13px" }}>
            View all stock split corporate actions
          </Typography>
        </Box>
      </Box>

      {/* Table Card */}
      <Box
        sx={{
          background: "#fff",
          borderRadius: "12px",
          border: "1px solid #e2e8f0",
          boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
          overflow: "hidden",
        }}
      >
        <TableContainer component={Paper} elevation={0} sx={{ borderTop: "1px solid #eef2f7" }}>
          <Table>
            <TableHead>
              <TableRow>
                {["Symbol", "Corporate Actions", "Split Ratio", "Split Date", "Created At", "Split Done"].map((label) => (
                  <TableCell
                    key={label}
                    sx={{
                      fontWeight: 700,
                      fontSize: "13px",
                      color: "#fff",
                      background: "#04343a",
                      borderBottom: "none",
                      padding: "12px 16px",
                    }}
                  >
                    {label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {splits.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center" sx={{ py: 5, color: "#94a3b8" }}>
                    No stock splits available.
                  </TableCell>
                </TableRow>
              ) : (
                splits.map((split) => (
                  <TableRow key={split.id} sx={{ "&:hover": { background: "#f0faf5" } }}>
                    <TableCell>
                      <Typography sx={{ fontWeight: 600, color: "#016551", fontSize: "14px" }}>
                        {split.symbol_name}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ color: "#64748b", fontSize: "13px" }}>{split.corporate_action}</TableCell>
                    <TableCell sx={{ color: "#64748b", fontSize: "13px" }}>{split.split_ratio}</TableCell>
                    <TableCell sx={{ color: "#64748b", fontSize: "13px" }}>{new Date(split.split_at).toLocaleDateString()}</TableCell>
                    <TableCell sx={{ color: "#64748b", fontSize: "13px" }}>{new Date(split.created_at).toLocaleDateString()}</TableCell>
                    <TableCell sx={{ color: "#64748b", fontSize: "13px" }}>{split.issplit ? "Yes" : "No"}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default StockSplit;
